<template>
  <div class="project">
    <div class="content-left">
      <el-tabs tab-position="left" style="height: auto;overflow:auto;width:100%;" @tab-click="visitDoctor">
        <el-tab-pane v-for="(item,index) in uDoctor" :key="index" :label="item.name">
          <div class="itab">
            <el-table
              :data="tableData"
              border
              :header-cell-style="tableHeaderColor"
              @row-click="thRow"
            >
              <el-table-column label="时间" width="auto">
                <template scope="scope">
                  <el-icon name="time"></el-icon>
                  <span style="margin-left: 10px">{{ scope.row.periodOfTime }}</span>
                </template>
              </el-table-column>

              <el-table-column label="预约人" width="auto">
                <template scope="scope">
                  <div slot="reference" class="name-wrapper">
                    <p class="op">{{ scope.row.patient.name }},{{ scope.row.patient.age }},{{ scope.row.patient.gender}}</p>
                    <p class="op">{{ scope.row.patient.mobileNumber }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="patient.level" label="会员等级">
                <template slot-scope="scope">
                  <el-tag
                    :type="scope.row.patient.level==='1' ? 'primary' : (scope.row.patient.level==='2' ? 'warning'
                            : (scope.row.patient.level==='3'?'danger':'success'))"
                  >
                    {{scope.row.patient.level === '1' ? '普通会员' : (scope.row.patient.level === '2' ? '银卡会员'
                    : (scope.row.patient.level === '3' ? '金卡会员' : '铂金会员'))}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="看诊医生" width="auto">
                <template scope="scope">
                  <div slot="reference" class="name-wrapper">
                    <p class="phone-s">{{ scope.row.doctorName }}</p> 
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="状态"
                width="auto"
                prop="reservationStatus"
                :filters="[{ text:'候诊' , value: 1 }, { text: '看诊', value: 2 }, { text: '结束看诊', value:  3}]"
                :filter-method="filterTag"
                filter-placement="bottom-end"
              >
                <template scope="scope">
                  <el-tag :type="scope.row.reservationStatus==1?'success':'info'">候诊</el-tag>
                  <el-tag :type="scope.row.reservationStatus==2?'success':'info'">看诊</el-tag>
                  <el-tag :type="scope.row.reservationStatus==3?'success':'info'">结束看诊</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="auto">
                <template scope="scope">
                  <el-button
                    v-if="scope.row.reservationStatus!=1"
                    disabled
                    type="primary"
                    icon="el-icon-edit-outline"
                  >看诊</el-button>
                  <el-button
                    v-else
                    type="primary"
                    icon="el-icon-edit-outline"
                    v-on:click.stop="inquiry(tableData,scope.$index)"
                  >看诊</el-button>
                  <!-- 编辑绿色按钮 -->
                  <el-button
                    v-show="scope.row.supplementStatus"
                    type="success"
                    icon="el-icon-edit-outline"
                    v-on:click.stop="inquiryc(tableData,scope.$index)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import "../../assets/css/style1.css";

export default {
  data() {
    return {
      uDoctor: [], // 医生数据
      tableData: [],
      arrlength: "",
      timeOut: null
    };
  },
  methods: {
    filterTag(value, row) {
      return row.reservationStatus === value;
    },
    inquiryc(tab, index) {
      let row = tab[index];
      if (row != null) {
        this.$router.push({
          path: "/home/compileC",
          query: {
            user:{
              name:row.patient.name,
              gender:row.patient.gender,
              age:row.patient.age,
              phone:row.patient.mobileNumber,
              patientId:row.patient.id
            },
            cid:row.reservationId
          }
        });
      }
    },
    inquiry(tab, index) {
      // 点击问诊按钮
      let row = tab[index];
      if (row.reservationStatus != 3) {
        this.$axios({
          url: "/api/reservation/inquiry/" + row.reservationId,
          method: "PUT"
        })
          .then(res => {
            this.$router.push({
              path: "/home/Inquiry",
              query: {
                rowData: row.reservationId,
                dName: row.doctorName,
                dTime: row.periodOfTime,
                pid: row.patient.id,
                did: row.doctorId,
                sta: row.reservationStatus,
                length: this.arrlength
              }
            });
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    thRow(row, event, column) {
      if (row.reservationStatus != 3) {
        this.$router.push({
          path: "/home/Inquiry",
          query: {
            rowData: row.reservationId,
            dName: row.doctorName,
            dTime: row.periodOfTime,
            pid: row.patient.id,
            did: row.doctorId,
            sta: row.reservationStatus,
            length: this.arrlength
          }
        });
      }
    },
    visitDoctor(tab) {
      let doctorId = this.uDoctor[tab.index].id;
      this.getData(doctorId); // 点击医生获取数据
    },
    doctor(uid) {
      this.$axios({
        url: "/api/user/usersByRolename",
        method: "GET",
        params: {
          rolename: "医生"
        }
      })
        .then(res => {
          let resData = res.data.data;
          for (let i = 0; i < resData.length; i++) {
            if (resData[i].id == uid) {
              // 医生进入 只展示医生
              this.getData(resData[i].id);
              this.uDoctor = resData[i];
              return;
            }
          }
          this.getData(resData[0].id);
          this.uDoctor = resData;
          this.timeOut = setTimeout(() => {
            this.doctor(localStorage.uid);
          }, 60000);
        })
        .catch(err => {
          console.log(err);
          clearTimeout(this.timeOut);
        });
    },
    getData(dId) {
      this.$axios({
        url: "/api/reservation/inquiry/" + dId,
        method: "GET"
      })
        .then(res => {
          let resData = res.data.data;
          if (resData.length == 0) {
            this.$router.push({
              path: "/home/Noinquiry"
            });
          }
          this.tableData = resData;
          let arr = [];
          for (let k = 0; k < resData.length; k++) {
            if (resData[k].reservationStatus == 1) {
              arr.push(resData[k]);
            }
          }
          this.arrlength = arr.length;
        })
        .catch(err => {
          console.log(err);
        });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#f2f2f2;color: #a4a7af;";
      }
    }
  },
  created() {
    this.doctor(localStorage.uid);
  },
  destroyed() {
    clearTimeout(this.timeOut);
  }
};
</script>

<style type="text/css" scoped>
  .el-button--primary {
    color: #fff;
    background-color:  rgb(60, 110, 169);
    border-color: rgb(60, 110, 169);
  }
  .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #fff;
    background-color: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
  }
</style>



// WEBPACK FOOTER //
// inquiryList.vue?fa8a4c30